<template>
    <Transition name="fade">
        <div v-if="isVisible" class="base-toast-content">
            <div v-html="message"></div>
        </div>
    </Transition>
</template>

<script setup>
import {watch, onBeforeUnmount} from 'vue';

const props = defineProps({
    isVisible: Boolean,
    message: String,
});
const emit = defineEmits(['close', 'after']);

let timeout;

watch(
    () => props.isVisible,
    (newVal) => {
        if (newVal) {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                emit('close');
                emit('after');
            }, 3000);
        }
    },
);

onBeforeUnmount(() => {
    clearTimeout(timeout);
});
</script>
<style lang="scss" scoped>
.base-toast-content {
    padding: 16px 40px;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translate(-50%, 0%);
    max-width: 560px;
    max-height: calc(100vh - 120px);
    background: rgba(0, 0, 0, 0.8);
    border-radius: 8px;
    color: $white;
    word-break: break-all;
    font-size: 14px;
    line-height: 21px;
    overflow-y: auto;
    z-index: $modal-z-index;

    @media (max-width: 500px) {
        max-width: calc(100vw - 80px);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
